import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectLanguage } from '@ninety/platform/state/app-global/language/language.selectors';
import { COMPANY_LANGUAGE_STREAM, FOLLOWER_NOTIFIER, FollowerNotifier } from '@ninety/ui/core';
import { NotifyService } from '@ninety/ui/legacy/core/services/notify.service';

/**
 * Binds the tokens consumed by `FollowersComponent` / `FollowersListComponent` in `@ninety/ui/core` to
 * their platform-backed implementations: follow/unfollow notifications (`NotifyService`) and the
 * company-language stream (`selectLanguage`). The components stay free of the `platform/state`-coupled
 * `NotifyService` and of `@ninety/platform/state` so they can be packaged in the public API; this
 * composition-root wiring is the single place that depends on both the tokens and those deps.
 * (DEV-26530 6a)
 */
export const FOLLOWERS_PROVIDERS: Provider[] = [
  {
    provide: FOLLOWER_NOTIFIER,
    useFactory:
      (notifyService: NotifyService): FollowerNotifier =>
      (message, params) =>
        notifyService.notifyV2(message, params),
    deps: [NotifyService],
  },
  {
    provide: COMPANY_LANGUAGE_STREAM,
    useFactory: (store: Store) => store.select(selectLanguage),
    deps: [Store],
  },
];
